"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV2RemoteRetrieve = void 0;
exports.v2RemoteRetrieveSetMock = v2RemoteRetrieveSetMock;
exports.v2RemoteRetrieve = v2RemoteRetrieve;
exports.useMutationV2RemoteRetrieve = useMutationV2RemoteRetrieve;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v2RemoteRetrieveSetMock(mock) {
    setMock = mock;
}
async function v2RemoteRetrieve(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/cockatoo/v2/remote/retrieve`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if ((params.forceStatusCheck) && (await (0, is_down_1.cockatooIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'POST', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV2RemoteRetrieve = 'cockatoo:v2RemoteRetrieve:post';
function useMutationV2RemoteRetrieve(mutationOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    return reactQuery.useMutation(mutationFn, Object.assign({ mutationKey: exports.useKeyV2RemoteRetrieve }, mutationOptions));
}
function mutationFn({ params }) {
    const promise = v2RemoteRetrieve(params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v2-remote-retrieve.js.map